/**
 * @fileoverview Agent definition for structural-suggestions-v1.
 *
 * Proposes concrete structural changes to storyline structure based on
 * divergence analysis. Produces reviewable suggestions (move, add, remove
 * beats; change priority; add storylines) — never auto-applied.
 *
 * Uses Gemini Pro for stronger reasoning when crafting structural proposals.
 *
 * @category narrative.story.operations
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'structural-suggestions-v1',
  kind: 'primitive',
  name: 'Structural Suggestions',
  description: 'Proposes structural changes to storylines (beat moves, additions, removals, priority changes) based on divergence analysis.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.operations',
    usedBy: [],
    usedInComposites: [
      'structural-refresh-composite-v1',
    ],
    relatedAgents: [
      'divergence-report-v2',
      'storyline-refresher-v2',
    ],
  },
};
